function siglaInputDirective() {
	var si = {};
	
	si.scope = {
		sigla: "=",
		maxlenght: "=",
		required: "@?",
		
	}
	
	si.template = function(elem, attr, s) {
		return '<input ng-trim="false" ng-change="onChange()" ng-required="isRequired" type="text" ng-model="sigla" placeholder="Sigla" name="sigla" ng-maxlength="maxlenght" class="form-control" style="text-transform:uppercase">';
	}
	
	si.controller = ['$scope' , function($scope){
		
		$scope.isRequired = angular.isDefined($scope.required);
		

		
		$scope.onChange = function(){
			if(angular.isUndefined($scope.sigla))
				return;
			$scope.sigla = $scope.sigla.replace(/\s/g, "");
			$scope.sigla = $scope.sigla.toUpperCase();
		}
	}]
	
	return si;
};

module.directive('siglaInput', [ siglaInputDirective ]);
